module.exports = "<svg viewBox=\"0 0 100 100\" [ngStyle]=\"{width:size, height:size}\">\n  <circle cx=\"50\" cy=\"50\" r=\"40\"></circle>\n</svg>\n"